import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { CustomParams, Meta, Query, LocalizedLabels, RatatoskRequest, RatatoskPage, RatatoskResponse, getLocalizedLabel, getmeta, featureValueTypes, valueInOptions, valueByFormikPath, createDefaultFeatureLabel, valueNotEmpty, valueIsIntNumber, valueOnceOnly, createSlotDescription, getSlotDescription, descSlot } from '../../common'
import { AxiosInstance } from 'axios'
import { withTranslation, WithTranslation } from 'react-i18next'
import { Button, Container, DropdownItemProps, Dropdown as PDropdown, Grid, Header, Message, Segment, Tab, Table, Modal } from 'semantic-ui-react'
import { addFeature, EditFormProps, lastChangeLabel } from '../Edit'
import { FieldArray } from 'formik'
import { setFieldValue } from './FormikHelpers'
import Input from './Input'
import Dropdown from './Dropdown'
import EditSlotFillerFormFeatures from './EditSlotFillerFormFeatures'
import EditFillerForm from './EditFillerForm'

interface EditSlotFormState {
    moveFillerModal: any,
    moveFillerTarget: string
}

class EditSlotForm extends Component<EditFormProps, EditSlotFormState> {

    state = {
        moveFillerModal: null as any,
        moveFillerTarget: ''
    }

    componentDidMount() {
    }

    render() {
        const { formik, meta, t, http, i18n, params, userMap, history, location } = this.props
        const { moveFillerModal, moveFillerTarget } = this.state
        const slots = formik.values.slots
        const features = formik.values.feats

        const slotTypes: DropdownItemProps[] = Object.keys(meta.cats['slot']).reduce((res: DropdownItemProps[], type) => {
            const s = meta.cats['slot'][type]
            if (!s.subdef_required)
                res.push({key: type, value: type, text: getLocalizedLabel(s.label, i18n.language)})
            return res
        }, [])

        const fillerTypes: DropdownItemProps[] = Object.keys(meta.cats['filler']).reduce((res: DropdownItemProps[], type) => {
            const f = meta.cats['filler'][type]
            if (!f.subdef_required)
                res.push({key: type, value: type, text: getLocalizedLabel(f.label, i18n.language)})
            return res
        }, [])

        const filterFlTypes = (types: DropdownItemProps[], params) => {
            if (!(params['restr_contents'] && params['restr_contents']['filler_type']))
                return types
            const allowed = params['restr_contents']['filler_type']
            return (types.filter(o => {
                const value = o.value as string
                return allowed.includes(value) || allowed.some(t => value.startsWith(t+':'))
            }))
        }

        const newSlotNum = slots.reduce((max, s) => { 
            if (s._id.startsWith('__new_')) {
                const n = parseInt(s._id.substr(6))
                if (n > max) max = n
            }
            return max
        }, 0) + 1

        const newSlot = {
            _id: '__new_' + newSlotNum,
            _pos: slots.length+1,
            _type: '',
            name: String(slots.length + 1),
            type: ':term:fixed',
            fillers: [],
            delete: false
        }

        const slotOptions = slots.reduce((acc, s) => {
            if (!s.delete) acc.push({key: s._id, value: s._id, text: descSlot(meta, formik.values, s._id, t)})
            return acc
        }, [])

        const slotIsNew = (slot: any) => {
            return slot._id.startsWith('__new_')
        }

        const openMoveFillerModal = (sid, fid, fPath) => {
            const defaultTargetSlot = slots.findLast(s => !s.delete && s._id !== sid)?._id
            this.setState({moveFillerModal: {slotId: sid, fillerId: fid, fillerPath: fPath}, moveFillerTarget: defaultTargetSlot})
        }

        const moveFiller = (params: {slotId: string, fillerId: string, fillerPath: string}, targetSlotId: string) => {
            const fillerCopy = JSON.parse(JSON.stringify(valueByFormikPath(params.fillerPath, formik.values)))
            setFieldValue(formik, params.fillerPath+'.delete', true, true)
            const targetSlotIndex = formik.values.slots.findIndex(s => s._id===targetSlotId)
            const cnt = formik.values.slots[targetSlotIndex].fillers.length
            const newId = '__new_' + String(cnt+1)
            fillerCopy['_id'] = newId
            fillerCopy['name'] = String(cnt+1)
            setFieldValue(formik, "slots['"+targetSlotIndex+"'].fillers['"+cnt+"']", fillerCopy, true)
            const oldFillerId = params.slotId+'/'+params.fillerId
            const newFillerId = targetSlotId+'/'+newId
            Object.keys(formik.values.feats).forEach((basetype) => {
                let cnt = 0
                if (formik.values.feats[basetype][oldFillerId])
                    formik.values.feats[basetype][oldFillerId].forEach((feature) => {
                        const fCopy = JSON.parse(JSON.stringify(feature))
                        fCopy['_slot'] = targetSlotId
                        fCopy['_filler'] = newId
                        setFieldValue(formik, "feats['"+basetype+"']['"+newFillerId+"']['"+cnt+"']", fCopy, true)
                        cnt++
                    })
            })
            this.setState({moveFillerModal: null})
        }

        return(
            <div>
            <Modal open={!!moveFillerModal}>
                <Modal.Header>{t('Move filler to slot')}</Modal.Header>
                <Modal.Content>
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={16}>
                            <PDropdown fluid selection label={t('Slot')} value={moveFillerTarget}
                                onChange={(e,{value}) => this.setState({moveFillerTarget: value as string})}
                                options={slotOptions.filter(o => o.value !== moveFillerModal?.slotId)}/>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Modal.Content>
                <Modal.Actions>
                    <Button color="red" onClick={() => this.setState({moveFillerModal: null})}>{t('Cancel')}</Button>
                    <Button color="blue" onClick={()=> moveFiller(moveFillerModal, moveFillerTarget)} disabled={!moveFillerTarget}>{t('Move')}</Button>
                </Modal.Actions>
            </Modal>
            <FieldArray name={"slots"} render={(subformik) => (
                    <>
                    {slots.map((s, si) => {
                        const spath = "slots."+si
                        const sdelete = spath+".delete"
                        const fillers = slots[si].fillers
                        const sdeleted = s.delete
                        //const stype = "slot_"+s.type.replaceAll(':','_') + (sdeleted ? ' deleted' : '')
                        const smeta = getmeta(meta, 'slot', s.type)
                        const myFillerTypes = smeta ? filterFlTypes(fillerTypes, smeta.params) : []

                        const newFillerNum = fillers.reduce((max, f) => { 
                            if (f._id.startsWith('__new_')) {
                                const n = parseInt(f._id.substr(6))
                                if (n > max) max = n
                            }
                            return max
                        }, 0) + 1
                        
                        const newFiller = {
                            _id: '__new_' + newFillerNum,
                            _type: '',
                            name: String(fillers.length + 1),
                            type: s.type === ':var' ? ':node' : '',
                            delete: false
                        }

                        const style = sdeleted ? {} : {
                            backgroundColor: smeta.params?.color || 'white'
                        }

                        return (
                            <div className={"slot" + (sdeleted ? ' deleted' : '')} style={style}>
                                <Table compact>
                                <Table.Body>
                                <Table.Row className="header">
                                    <Table.Cell>
                                        <strong>[{si+1}] {t('Slot')}&nbsp;</strong>
                                        <Input name={spath+".name"} inputProps={{disabled: sdeleted, size: 'mini'}}
                                            validate={(v) => valueOnceOnly(v, slots.map(x => { if (!x.delete) return x.name} ))}/>
                                            &nbsp;
                                        <div className="buttons">
                                        <Button type="button" icon="angle right" color="yellow" size="mini" title={t('swap with the following')}
                                            disabled={si === slots.length-1}
                                            onClick={(e,d) => {subformik.swap(si, si+1);formik.setFieldTouched(spath, true, true)}}/>    
                                        { s.delete ?
                                        <Button type="button" icon="undo alternate" color="yellow" size="mini" title={t('undo')}
                                            onClick={(e,d) => {
                                                setFieldValue(formik, sdelete, false, true)
                                            }}/>
                                        : slotIsNew(s) ?
                                        <Button type="button" icon="delete" color="red" size="mini" title={t('delete')}
                                            onClick={(e,d) => {subformik.remove(si)}}/>
                                        :
                                        <Button type="button" icon="delete" color="red" size="mini" title={t('delete')}
                                            onClick={(e,d) => {
                                                setFieldValue(formik, sdelete, true, true)
                                            }}/>
                                        }
                                        </div>
                                    </Table.Cell>
                                </Table.Row>
                                <Table.Row>
                                    <Table.Cell>
                                        <Dropdown name={spath+".type"} options={slotTypes} inputProps={{disabled: sdeleted}}
                                            validate={v => valueInOptions(v, slotTypes)}/>
                                    </Table.Cell>
                                </Table.Row>

                                <Table.Row>
                                    <Table.Cell>
                                        <label className="fgroup_label">{t('Features')}</label>
                                    </Table.Cell>
                                </Table.Row>
                                <EditSlotFillerFormFeatures formik={formik} userMap={userMap} http={http} meta={meta}
                                    featureList={params['slot_features']} compId={s._id} compDeleted={sdeleted} parentMeta={smeta}/>

                                <FieldArray name={"slots."+si+".fillers"} render={(subformik) => (
                                    <>
                                    <Table.Row>
                                        <Table.Cell>
                                            <label className="fgroup_label">{t('Fillers')}</label>
                                            <Button type="button" icon="plus" color="blue" size="mini" title={t('add new filler')}
                                                onClick={(e,d) => subformik.push(newFiller)}/>
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                    <Table.Cell colspan="3">
                                    <div>
                                    {fillers.map((fl, fli) => (
                                        <EditFillerForm key={s._id+'/'+fl._id} http={http} meta={meta} formik={formik} subformik={subformik} params={params} userMap={userMap} slotDeleted={sdeleted}
                                            prefix={"slots."+si+".fillers."+fli} filler={fl} fillerId={s._id+'/'+fl._id} fillerIndex={fli} fillers={fillers}
                                            fillerTypes={fillerTypes} moveFiller={() => {openMoveFillerModal( s._id, fl._id, "slots."+si+".fillers."+fli)}}/>
                                    ))}
                                    </div>
                                    </Table.Cell>
                                    </Table.Row>
                                    </>)
                                    }/>
                                </Table.Body>
                                </Table>
                            </div>
                        )
                    })}
                    <div className="slot">
                        <Button type="button" icon="plus" color="blue" size="mini" title={t('add new slot')}
                            onClick={(e,d) => subformik.push(newSlot)}/>
                    </div>
                    </>
                    )
                }/>
            </div>
        )
    }

}

/*<div><pre>{JSON.stringify(formik.values,null, 2)}</pre></div>*/

export default withTranslation()(EditSlotForm)